import { TabContext, TabPanel } from "@mui/lab";
import { TabLinks } from "components/TabLinks";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useSearchParams } from "react-router-dom";

import { CustomerRolesTab } from "./CustomerRolesTab";
import { StaffRolesTab } from "./StaffRolesTab";

/**
 * Roles page. Two tabs:
 *  - `?tab=customer` (default) — a selected org's customer roles (tenant-scoped)
 *  - `?tab=staff`             — global Encamp staff roles (tenantless)
 *
 * Tab routing matches the Feature Flags page — `?tab=...` URL param, no nested
 * routes.
 */
export function Roles() {
  useBreadcrumb({ label: "Roles" });
  const [searchParams] = useSearchParams();

  const tabs = [
    { title: "Customer Roles", to: ".?tab=customer", component: <CustomerRolesTab /> },
    { title: "Staff Roles", to: ".?tab=staff", component: <StaffRolesTab /> },
  ];

  const selectedTabVal =
    tabs.find((t) => t.to === `.?tab=${searchParams.get("tab")}`)?.to ?? tabs[0].to;

  return (
    <TabContext value={selectedTabVal}>
      <TabLinks tabs={tabs} value={selectedTabVal} />
      {tabs.map((tab) => (
        <TabPanel key={tab.to} value={tab.to} sx={{ px: 3, py: 3 }}>
          {tab.component}
        </TabPanel>
      ))}
    </TabContext>
  );
}
